<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Button from "./Button.svelte";
  import Icon from "./Icon.svelte";

  export let klass: string = "is-primary";
  export let text: string = "";
  export let accept: string = "";

  let inputElement: HTMLInputElement;

  const dispatch = createEventDispatcher();

  function onUploadFile() {
    inputElement.click();
  }

  function onInputChange() {
    const file = inputElement.files.item(0);
    dispatch("fileUpload", file);
  }

  // accept="text/plain"
</script>

<span class="whole-btn">
  <input class="hidden-input" type="file" {accept} bind:this={inputElement} on:change={onInputChange} />
  <Button {klass} on:click={onUploadFile}>
    <Icon name="note_add" handleClick={false} />
    <span>{text}</span>
  </Button>
</span>

<style>
  .hidden-input {
    /*visibility: hidden;*/
    display: none;
  }

  .whole-btn {
    display: inline-block;
  }
</style>
